import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import BaseMarketingController from "./BaseMarketingController";
import NtHomeSection from "../components/home/NtHomeSection";
import NtHomeConnectYourWaySection from "../components/home/NtHomeConnectYourWaySection";
import NtHomeConnectAtSeaSection from "../components/home/NtHomeConnectAtSeaSection";
import NtHomeNextGenSection from "../components/home/NtHomeNextGenSection";
import NtHomeBYODSection from "../components/home/NtHomeBYODSection";
import NtHomeMilitarySection from "../components/home/NtHomeMilitarySection";

// images
import image from "../../assets/images/marketing/share.png";

class MarketingController extends BaseMarketingController {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer>
        <NtHomeSection />
        <NtHomeConnectYourWaySection />
        <NtHomeConnectAtSeaSection />
        <NtHomeNextGenSection />
        <NtHomeBYODSection />
        <NtHomeMilitarySection />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default MarketingController;
